import React from "react";

import {ReactComponent as PromoIcon} from "../images/icons/promotions.svg";
import {ReactComponent as Info} from "../images/icons/info.svg";

import img1 from "../images/cards/promo/card-1.png";

const PromoDB = [

      {
        image: img1,
        name: 'Cash Drop $30,000',
        icon: <Info/>
      },
      {
        image: img1,
        name: 'Cash Drop $30,000',
        icon: <Info/>
      },

      {
        image: img1,
        name: 'Cash Drop $30,000',
        icon: <Info/>
      },
      {
        image: img1,
        name: 'Cash Drop $30,000',
        icon: <Info/>
      },
  {
    image: img1,
    name: 'Cash Drop $30,000',
    icon: <Info/>
  },
  {
    image: img1,
    name: 'Cash Drop $30,000',
    icon: <Info/>
  },

  {
    image: img1,
    name: 'Cash Drop $30,000',
    icon: <Info/>
  },
  {
    image: img1,
    name: 'Cash Drop $30,000',
    icon: <Info/>
  }


]
export default PromoDB